"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "12",
  height: "10",
  viewBox: "0 0 12 10"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M11.53 5.9c.33-.21.47-.58.47-.9 0-.32-.14-.69-.47-.9L5.46.14a.9.9 0 00-1.02.02c-.28.2-.44.52-.44.89v.74L1.46.15A.9.9 0 00.44.17C.16.37 0 .69 0 1.06v7.88c0 .36.16.7.44.89a.9.9 0 001.02.02L4 8.2v.74c0 .36.16.7.44.89a.9.9 0 001.02.02l6.07-3.95zM4 7L1 8.97V1.06v-.02l5.98 3.9L7 5l-.01.06L4 7H4zm1 .55L7.53 5.9C7.86 5.7 8 5.32 8 5c0-.32-.14-.69-.47-.9L5 2.44v-1.4l5.98 3.88v.01L11 5l-.01.06L5 8.97V7.54z"
}));

exports["default"] = _default;